export default function plural(number, word) {
	return number === 1 ? `${number} ${word}` : `${number} ${word}s`
}



// WEBPACK FOOTER //
// ./src/lib/plural.js